import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpHelperService } from '@helpers/http-helper.service';
import { PauseI, UserPausedI } from '@interfaces/chat.interface';
import { firstValueFrom, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ReportPauseService {
  private baseUrl = environment.OMNISMART_API_ATTENDANCE_REPORTS + 'report-pause';

  constructor(private httpHelperService: HttpHelperService, private http: HttpClient) {}

  getUserInPause(userId: string, customerId: string): Observable<UserPausedI> {
    return this.http.get<UserPausedI>(`${this.baseUrl}/paused-user?userId=${userId}&customerId=${customerId}`);
  }

  getTotalPauseDay(userId: string, day: string): Observable<PauseI> {
    return this.http.get<PauseI>(`${this.baseUrl}/last-pause?user=${userId}&day=${day}`);
  }

  startPause(body: PauseI): Observable<PauseI> {
    return this.postPause(`${this.baseUrl}/start-pause`, body);
  }

  stopPause(body: PauseI): Observable<PauseI> {
    return this.postPause(`${this.baseUrl}/end-pause`, body);
  }

  public async endPausePabxByUserId(userId: string, customerId: string) {
    return firstValueFrom(
      this.postPause(`${this.baseUrl}/end-pause-pabx-by-user`, { user: userId, customer: customerId })
    );
  }
  private postPause(url: string, body: any) {
    return this.http.post<PauseI>(url, body);
  }

  public async startPausePabxByUserId(userId: string, customerId: string, callId?: string) {
    return firstValueFrom(
      this.postPause(`${this.baseUrl}/start-pause-pabx-by-user`, { user: userId, customer: customerId, callId })
    );
  }

  public endPauseByUserId(userId: string, customerId: string) {
    return this.http.post<PauseI>(`${this.baseUrl}/end-pause-by-user`, { user: userId, customer: customerId });
  }

  public usersInPause(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/users-in-pause`);
  }

  public getReportData<TypeFilter>(
    sortDirection = 'desc',
    pageIndex = 1,
    pageSize = 5,
    active = 'createdAt',
    filters: TypeFilter
  ): Observable<{ analyticalItems?: Array<PauseI>; consolidatedItems?: Array<any>; count: number }> {
    let params = new HttpParams()
      .set('sortDirection', sortDirection)
      .set('active', active)
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString());

    params = this.httpHelperService.setHttpParams(params, filters);
    return this.http.get<any>(this.baseUrl, { params });
  }

  public getCount<TypeFilter>(filters: TypeFilter): Observable<number> {
    const url = this.baseUrl + '/count';

    let params = new HttpParams();

    params = this.httpHelperService.setHttpParams(params, filters);

    return this.http.get<number>(url, { params });
  }

  public exportCSV(filters) {
    let params = new HttpParams();

    return firstValueFrom(
      this.http.get(`${this.baseUrl}/csv/exports`, {
        params: this.httpHelperService.setHttpParams(params, filters),
      })
    );
  }

  public exportExcel(filters) {
    let params = new HttpParams();
    return firstValueFrom(
      this.http.get(`${this.baseUrl}/excel/exports`, {
        params: this.httpHelperService.setHttpParams(params, filters),
      })
    );
  }
}
